import { NgModule } from '@angular/core';

import {
  CoreUiModule,
} from 'webcommon/core-ui';

import { ApColumnActionIconsComponent,
         ApColumnCheckboxComponent,
         ApColumnDateComponent,
          ApColumnDropdownComponent,
           ApColumnFindcontrolComponent,
            ApColumnHtmlComponent,
             ApColumnHyperlinkComponent,
              ApColumnNumberComponent,
               ApColumnStringComponent,
                ApColumnTimeFrameComponent,
                 ApConfigurableTableComponent,
         ApHyperlinkColumnSelectorComponent } from './ap-configurable-table/index';
import { FcGenericListComponent } from './ap-findcontrol/fc-item-component/fc-generic-list/fc-generic-list.component';
import { FcGenericListModalComponent } from './ap-findcontrol/fc-item-modals/fc-generic-list-modal/fc-generic-list-modal.component';

import {
  ApDxFindControlComponent,
  ApFindControlAdvancedComponent,
  ApFindControlComponent,
  ApFindControlGenericComponent,
  ApFindControlModalComponent,
  ApFindControlModifyInformationTabComponent,
  ApFindControlModifyModalComponent,
  ApFindControlModifySecurityTabComponent,
  FcMergeItemModalComponent,
} from './ap-findcontrol/index';
import {
  ApTimespanFindControlComponent,
  ApTimeSpanSelectorModalComponent,
} from './ap-timespan/index';
import { ApColumnExtFindControlComponent } from './ap-column-ext/ap-column-ext-findcontrol.component';
import { ApColumnExtTimeFrameComponent } from './ap-column-ext/ap-column-ext-timeframe.component';

const configurableTableExports = [
  ApColumnActionIconsComponent,
  ApColumnCheckboxComponent,
  ApColumnDateComponent,
  ApColumnDropdownComponent,
  ApColumnHyperlinkComponent,
  ApColumnNumberComponent,
  ApColumnStringComponent,
  ApColumnHtmlComponent,
  ApColumnTimeFrameComponent,
  ApColumnFindcontrolComponent,
  ApConfigurableTableComponent,
  ApHyperlinkColumnSelectorComponent
];

const exportComponents = [
  ApDxFindControlComponent,
  ApFindControlAdvancedComponent,
  ApFindControlComponent,
  ApFindControlGenericComponent,
  ApFindControlModalComponent,
  ApFindControlModifyInformationTabComponent,
  ApFindControlModifyModalComponent,
  ApFindControlModifySecurityTabComponent,
  ApTimespanFindControlComponent,
  ApTimeSpanSelectorModalComponent,
  FcGenericListModalComponent,
  FcGenericListComponent,
  FcMergeItemModalComponent,
  ApColumnExtFindControlComponent,
  ApColumnExtTimeFrameComponent,
];

const declareComponents = [
  ...exportComponents,
];

@NgModule({
  declarations: [
    declareComponents,
    ...configurableTableExports
  ],
  exports: [
    exportComponents,
    ...configurableTableExports
  ],
  imports: [
    CoreUiModule,
  ],
})
export class FindControlModule { }
